import type * as React from 'react';

import './map.popup.style.scss';

import MapRouteIcon from '../route-icon';

import { PopupContacts }      from './components';
import type { MapPopupProps } from './map.popup.props';

const MapPopup: React.FC<MapPopupProps> = function(props) {
  const {
          address,
          contacts,
          lat,
          lng,
          workingTime,
        } = props;

  return (
    <div className={'map-popup'}>
      {typeof address !== 'undefined' && <div className={'address'}>{address}</div>}
      {typeof contacts !== 'undefined' && <PopupContacts contacts={contacts} />}
      {typeof workingTime !== 'undefined' && (
        <div
          className={'working-time'}
          dangerouslySetInnerHTML={{ __html: workingTime }}
        />
      )}
      <button
        className={'popup-route-btn'}
        onClick={(event) => {
          event.stopPropagation();

          const url = `https://yandex.ru/maps/?rtext=~${lat},${lng}&rtt=auto`;

          window.open(url, '_blank', 'noopener, noreferrer');
        }}
      >
        <MapRouteIcon />
        Проложить маршрут
      </button>
      <div className={'arrow'} />
    </div>
  );
};

export default MapPopup;